export enum SessionStorageKeys {
  STORE_NUMBER = 'STORE_NUMBER'
}
